import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

function buildKioskUrl(url: string): string {
  return url.includes('?') ? `${url}&kiosk` : `${url}?kiosk`;
}

export function GrafanaHealthCard() {
  const { entity } = useEntity();
  const dashboardUrl = entity.metadata.annotations?.['grafana/dashboard-url'];

  if (!dashboardUrl) {
    return (
      <InfoCard title="Health">
        <span>No Grafana dashboard configured</span>
        <span>
          {' '}
          Add the <code>grafana/dashboard-url</code> annotation to your entity
          to embed a dashboard here.
        </span>
      </InfoCard>
    );
  }

  return (
    <InfoCard title="Health">
      <iframe
        title="Grafana Health Dashboard"
        src={buildKioskUrl(dashboardUrl)}
        width="100%"
        height="300"
        style={{ border: 'none' }}
      />
    </InfoCard>
  );
}
